import React, { useRef } from "react";
import { useParams } from "react-router-dom";
import { surahs } from "../data/surahs";
import { Link } from "react-router-dom"; // already likely imported in your app

function SurahPage() {
  const { surahId } = useParams();
  const surah = surahs.find((s) => s.id === parseInt(surahId));

  const fullSurahText = surah?.verses.map(v => v.text).join(" ");

  const isResponsiveVoiceReady = () => {
    return typeof window !== "undefined" && window.responsiveVoice;
  };

  const speak = () => {
    if (isResponsiveVoiceReady()) {
      window.responsiveVoice.speak(fullSurahText, "Arabic Male");
    }
  };

  const pause = () => {
    if (isResponsiveVoiceReady()) {
      window.responsiveVoice.pause();
    }
  };

  const resume = () => {
    if (isResponsiveVoiceReady()) {
      window.responsiveVoice.resume();
    }
  };

  const cancel = () => {
    if (isResponsiveVoiceReady()) {
      window.responsiveVoice.cancel();
    }
  };

  if (!surah) {
    return (
      <div className="p-6 text-center">
        <h2 className="text-3xl font-bold text-red-500">Surah Not Found</h2>
        <p className="mt-4">Sorry, we couldn't find the surah you're looking for.</p>
      </div>
    );
  }

  return (
    <div className="p-6 md:p-10">
      <h2 className="text-3xl font-bold text-center text-blue-700 mb-6">{surah.name}</h2>
      <p className="text-lg text-center mb-8">{surah.translation}</p>

      {/* Control Buttons */}
      <div className="flex justify-center mb-4">
  <Link
    to="/lessons/surahs"
    className="bg-gray-500 text-white px-4 py-2 rounded hover:bg-gray-600"
  >
    ← Back to Surahs
  </Link>
</div>
      <div className="flex justify-center gap-4 mb-8">
        <button onClick={speak} className="bg-green-500 text-white px-4 py-2 rounded hover:bg-green-600">Play</button>
        <button onClick={pause} className="bg-yellow-500 text-white px-4 py-2 rounded hover:bg-yellow-600">Pause</button>
        <button onClick={resume} className="bg-blue-500 text-white px-4 py-2 rounded hover:bg-blue-600">Resume</button>
        <button onClick={cancel} className="bg-red-500 text-white px-4 py-2 rounded hover:bg-red-600">Stop</button>
      </div>

      {/* Verses */}
      <div className="space-y-4" >
        {surah.verses.map((verse, index) => (
          <div key={index} className="bg-white p-4 rounded-lg shadow hover:shadow-lg transition"               onClick={() => isResponsiveVoiceReady() && window.responsiveVoice.speak(verse.text, "Arabic Male")}
>
            <div
              className="text-2xl text-blue-700 cursor-pointer"
            >
              {verse.text}
            </div>
            <div className="text-lg text-gray-600 italic mt-2">
              <em>{verse.transliteration}</em>
              <br/>
              <br/>
              <h2>Translation</h2>
              <em>{verse.translation}</em>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}

export default SurahPage;
